<template>
  <div class="test">
    <a-select
      :disabled="disabled"
      :multiple="false"
      :placeholder="placeholder"
      v-model:value="selectValue"
      allow-clear
      show-search
      optionFilterProp="title"
      @change="onChange"
      @search="onSearch"
      :virtual="false"
      @dropdownVisibleChange="addText = ''"
    >
      <!-- <a-select-option v-for="item in projectList" :key="item.id" :title="item.name" :value="item.id">
        {{ item.name }}
      </a-select-option> -->
      <a-select-option v-for="item in records" :key="item.id" :value="item.id" :title="item.name">
        <span v-if="item?.name?.indexOf(inpuText) > -1 && inpuText != ''">
          {{ item.name.substr(0, item?.name?.indexOf(inpuText))
          }}<span style="color: #f59a23 !important">{{ inpuText }}</span
          >{{ item.name.substr(item?.name?.indexOf(inpuText) + inpuText.length) }}
        </span>
        <span v-else> {{ item.name }} </span>
      </a-select-option>
      <template #dropdownRender="{ menuNode: menu }">
        <v-nodes :vnodes="menu" />
        <a-divider style="margin: 4px 0" />
        <div
          style="padding: 4px 12px; cursor: pointer"
          @mousedown="(e) => e.preventDefault()"
          @click="addProject"
        >
          <div class="ub ub-ac ub-ps" style="color: #333">
            <plus-outlined /><span style="width: 60px; white-space: nowrap">{{ tips }}</span
            ><span
              style="
                color: #2f7bff;
                margin-left: 2px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
              class="theme-color"
              v-if="addText"
              >”{{ addText }}“</span
            >
          </div>
        </div>
      </template>
    </a-select>
  </div>
</template>

<script lang="ts">
import { HttpService } from "@/core/index";
import { PlusOutlined } from "@ant-design/icons-vue";
import {
  onMounted,
  ref,
  PropType,
  watch,
  reactive,
  defineComponent,
  toRefs,
  computed,
  onActivated,
} from "vue";
import { ProfileService } from "@/views/project/profile/profile.service";
import { hmdConfirm } from "@/dialog/index";
import {
  ProfileSimpleListReq,
  ProfileSimpleRecord,
} from "@/views/project/profile/profile.interface";
import { generateUuid } from "@/utils";
import _ from "lodash";
import { SelectProps, Form } from "ant-design-vue";
import { useRoute } from "vue-router";
const tips = "新建项目";
/**
 * 项目选择器
 *
 * 使用方式:
 * <project-select v-model:value="formRef.projectId"></project-select>
 */
interface value {
  value?: string;
  label?: string;
}
export default defineComponent({
  isGlobal: true,
  name: "ProjectSelectDialog",
  props: {
    value: {
      type: String,
      default: "",
    },
    projectName: {
      type: String,
      default: "",
    },
    externalData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    addRightBizType: {
      type: String,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: "请选择项目",
    },
    // 其他状态
    // 技术方案: skillSolutionValidStatus
    // 招标申请: bidValidStatus
    // 招标文件购买申请: bidFileApplyValidStatus
    // 保证金申请: assuringMoneyApplyProcessStatus
    // 招标报价: bidOfferValidStatus
    /**
     * 可能后续不会用到
     */
    otherStatus: {
      type: Array,
      default: () => [],
    },
    // 项目状态, 从字典中获取, 字典值: project_status
    projectStatus: {
      type: Array,
      default: () => [],
    },
    //项目状态
    projectStatusList: {
      type: Array,
      default: () => [],
    },
    flowStatus: {
      type: Array,
      default: () => [],
    },
    api: {
      type: String,
    },
    bizType: {
      type: String,
    },
    defaultItem: {
      type: Array as PropType<ProfileSimpleRecord[]>,
      default: () => [],
    },
    req: {
      type: Object,
      default: () => {},
    },
  },
  emits: [
    "update:value",
    "update:projectId",
    "change",
    "visible",
    "selectChange",
    "update:projectInfo",
    "projectInfoChange",
  ],
  components: {
    PlusOutlined,
    VNodes: (_, { attrs }) => {
      return attrs.vnodes;
    },
  },
  setup(props, { emit }) {
    const formItemContext = Form.useInjectFormItemContext();
    const route = useRoute();

    const state = reactive({
      addText: "",
      inpuText: "",
      lists: [] as any,
      selectValue: undefined,
      isEdit: computed(() => !!route.params.id),
    });
    let { data: records, run, loading, refresh } = ProfileService.useSimpleListApi();
    const onChange = async (id) => {
      emit("update:value", id);
      formItemContext.onFieldChange();
      const tmp = records.value?.filter((i: any) => i.id === id);
      if (tmp) {
        emit("change", tmp[0]);
        emit("update:projectId", tmp[0]?.id);
        emit("selectChange", tmp[0]);
      }
      // 获取项目详情，用于返回给父组件使用
      if (id) {
        const res = await runProjectDetailRun(id);
        if (res.respCode === "0000") {
          emit("projectInfoChange", projectDetail);
        }
      }
    };
    const onSearch = (e) => {
      state.inpuText = e;
      const tmp = records.value.some((i: any) => i.name && i.name.indexOf(e) >= 0);
      if (!tmp) {
        state.addText = e;
      }
    };
    const addProject = () => {
      let projectName = state.addText;
      hmdConfirm({
        com: import("./components/project/index.vue"),
        params: {
          //@ts-ignore
          projectName: state.addText,
          projectId: props.value,
        },
        confirm: async ({ res }) => {
          await refresh();
          state.addText = "";
          let tmp = records.value.find((p) => p.id == res.id);
          if (tmp) {
            state.selectValue = res.id;
            emit("update:value", res.id);
            emit("change", {
              id: res.id,
              name: tmp.name,
              bizNo: tmp?.bizNo,
              status: tmp?.status,
            });
          } else {
            state.selectValue = undefined;
            emit("update:value", undefined);
            emit("change", {
              id: undefined,
              name: undefined,
            });
          }
          // emit("update:value", res.id);
          // emit("change", { id: res.id, name: projectName });
          formItemContext.onFieldChange();
        },
      });
    };
    const useDetailApi = () => {
      const api = (id) =>
        HttpService.axios({
          method: "GET",
          url: `/project/${id}`,
        });
      return HttpService.useRequest<any>(api);
    };
    const { run: runProjectDetailRun, data: projectDetail } = useDetailApi();
    // watch(
    //   () => state.selectValue,
    //   async (n) => {
    //     if (n) {
    //       // 获取项目详情，用于返回给父组件使用
    //       const res = await runProjectDetailRun(n);
    //       if (res.respCode === "0000") {
    //         // console.log(projectDetail, "projectDetail...");
    //         // emit("update:projectInfo", projectDetail)
    //         emit("projectInfoChange", projectDetail);
    //       }

    //       formItemContext.onFieldChange();
    //     }
    //   },
    //   { deep: true, immediate: true }
    // );
    const isIframe = computed(() => {
      return window.self !== window.top;
    });
    let isIframeChange = false;
    watch(
      () => props.value,
      (n, o) => {
        // console.log("n:" + n, "o:" + o, "id:" + state.selectValue, "-------==============---");
        if (state.selectValue != n && n && n !== "0") {
          //@ts-ignore
          state.selectValue = props.value;
          if (!records.value.some((i: any) => i.id === props.value)&&state.isEdit) {
            records.value.push({
              id: props.value,
              name: props.projectName || (route.query["projectName"] as string),
            });
          }
        } else if (!n) {
          state.selectValue = undefined;
        } else if (n === "0") {
          state.selectValue = undefined;
        }

        // console.log("🚀 ~ file: index.vue:282 ~ setup ~ records:", records);
      },
      {
        immediate: true,
      }
    );
    const init = async () => {
      const req = new ProfileSimpleListReq();
      // console.log(props.projectStatusList, "🚀 ~ file: index.vue:278 ~ init ~ req:", req);
      req.merge({
        projectStatus: props.projectStatus,
        projectStatusList: props.projectStatusList,
        otherStatus: props.otherStatus,
        flowStatus: props.flowStatus,
        bizType: props.bizType,
        addRightBizType: props.addRightBizType,
      });
      req.merge(props.req);
      // console.log(req.projectStatusList, "%^%^%^%^232323232");
      await run(req, props.api, req.projectStatusList);
      if (props.value) {
        //@ts-ignore
        state.selectValue = props.value;
        if (!records.value.some((i: any) => i.id === props.value)&&state.isEdit) {
          records.value.push({
            id: props.value,
            name: props.projectName || (route.query["projectName"] as string),
          });
        }
      }
      let array: any = JSON.parse(JSON.stringify(records.value));
      // props.defaultItem.forEach((item) => {
      //   if (!array.find((value) => value.id == item.id)) {
      //     array.push(item);
      //   }
      // });
      records.value = array;
    };
    const loadRouteQuery = () => {
      if (state.isEdit) return;
      if (route.query["projectId"]) {
        isIframeChange = true;
        // route.query['formType']=='general-add'&&
        if(!records.value.some((i: any) => i.id === route.query["projectId"])){
          onChange('');
        }else{
          onChange(route.query["projectId"]);
        }       
      }
    }
    onMounted(async () => {
      await init();
      loadRouteQuery();
    });
    onActivated(async () => {
      await init();
      loadRouteQuery();
    });

    return {
      ...toRefs(state),
      records,
      loading,
      onChange,
      init,
      addProject,
      onSearch,
      tips,
    };
  },
});
</script>
<style>
.heightlight-select .ant-select-item-option-active {
  color: #096dd9;
}

.heightlight-select {
  z-index: 111;
}
</style>
